import { Space } from 'antd';
import { StoryFramesModel } from 'interface/models';
import { StoryFrame } from './StoryFrame';
import { FrameHeader } from '../shared/FrameHeader';

export const StoryBoard_OneFrameRow = (props: {
  setNewTimeStart: any;
  onChange: (frame: StoryFramesModel) => void;
  qFrames: any;
  storyId: number;
  current: StoryFramesModel;
  next: StoryFramesModel;
  prev: StoryFramesModel;
  displayType: string;
}) => {
  const { next, prev, current, qFrames } = props;

  return (
    <>
      <FrameHeader
        key={current.id + `FrameHeader`}
        prev={prev}
        next={next}
        current={current}
        setNewTimeStart={props.setNewTimeStart}
        qFrames={qFrames}
        storyId={props.storyId}
        onChange={(frame: StoryFramesModel) => {
          props.onChange(frame);
        }}
        onReload={() => {
          qFrames.refetch();
        }}
      />
      <StoryFrame
        key={current.id + `StoryFrame`}
        frame={current}
        displayType={props.displayType}
        storyId={props.storyId}
        onChange={(frame: StoryFramesModel) => {
          props.onChange(frame);
        }}
        onReload={() => {
          qFrames.refetch();
        }}
      />
    </>
  );
};
